import { useState } from "react";
// import axios from 'axios';
import { Box, TextField, Button } from "@mui/material";
import { EmailVerificationSuccess } from "./EmailVerificationSuccess";
import { EmailVerificationFail } from "./EmailVerificationFail";
import { useToken } from "../auth/useToken";
import { useQueryParams } from "../hooks/useQueryParams";
import { SERVER_URL } from "../app/constant";

export const EmailVerificationCodePage = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailure, setIsFailure] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [verificationString, setVerificationString] = useState("");
  const { email } = useQueryParams();
  const [, setToken] = useToken();

  const onSubmitVerificationString = async () => {
    setIsSubmitting(true);
    try {
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          verificationString: verificationString,
        }),
      };
      const response = await fetch(`${SERVER_URL}/verify-email`, requestOptions);
      if (!response.ok) {
        throw new Error("Invalid verification code");
      }
      const data = await response.json();
      setToken(data.token);
      setIsSuccess(true);
    } catch (e) {
      setIsFailure(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) return <EmailVerificationSuccess />;
  if (isFailure) return <EmailVerificationFail />;

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "#3366BB" }}>Please Verify Your Email</h1>
      <p>
        You should have received a verification code at the email address you
        provided. Please enter it here:
      </p>
      <TextField
        sx={{ width: "300px", mt: 2 }}
        id="email-verification-code"
        label="Verification Code"
        placeholder="e.g. 123456"
        value={verificationString}
        onChange={(e) => setVerificationString(e.target.value)}
      />
      <Button
        variant="contained"
        sx={{ width: "300px", mt: 2 }}
        disabled={!verificationString || isSubmitting}
        onClick={onSubmitVerificationString}
      >
        {isSubmitting ? "Submitting..." : "Submit"}
      </Button>
    </Box>
  );
};
